import React from 'react'
import CategoryHeader from '../../../Components/Headers/CategoryHeader'
import DocForm from './DocForm'

const DocUpload = () => {
    return (
        <div>
            <div className=" ">
                <CategoryHeader title="Health Insurance" />
            </div> 
            <DocForm />
        </div>
    )
}

export default DocUpload